/**
 * Spike-only stub for `next/link`. Renders an <a>. For the production
 * migration, replace with react-router-dom's <Link> which does the
 * client-side navigation without a page reload.
 */
import type { AnchorHTMLAttributes, PropsWithChildren } from "react";

type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  prefetch?: boolean;        // ignored
  scroll?: boolean;          // ignored
  replace?: boolean;         // ignored
};

export default function Link({ href, children, prefetch: _p, scroll: _s, replace: _r, ...rest }: PropsWithChildren<LinkProps>) {
  return (
    <a href={href} {...rest}>
      {children}
    </a>
  );
}
